import { useEffect, useState } from "react";
import { FieldError, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { has } from "lodash";
import { useAxios } from "../../utils/useAxios";
import { Button, CircularProgress } from "@mui/material";
import { Modal } from "../ui/modal";
import FormBuildTabs from "../../plugins/formBuilder/FormBuildTabs";
import { useModal } from "../../hooks/useModal";
import MuiModel from "../Mui/model/MuiModel";
import { isEmpty } from "lodash";

interface MyCreateSelectProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  error?: FieldError;
  validationRules?: object;
  selected?: any;
  createName?: string;
  labelKey?: string;
  valueKey?: string;
  searching_key?: string;
  display_searching_key?: string;
}
export function MyCreateSelect({
  name,
  register,
  setValue,
  error,
  validationRules,
  selected,
  createName,
  labelKey = "factoring_name",
  valueKey = "id",
  searching_key = "id",
  display_searching_key = "name",
  ...rest
}: MyCreateSelectProps) {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState<any[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [displayValue, setDisplayValue] = useState("");

  // Add effect to handle form reset and initial value
  useEffect(() => {
    if (selected) {
      // If selected is an object with the expected keys
      if (typeof selected === "object" && selected !== null) {
        setDisplayValue(
          selected[display_searching_key] || selected[labelKey] || "",
        );
      } else {
        // If selected is a primitive value
        setDisplayValue(String(selected));
      }
    } else {
      setDisplayValue("");
      setQuery("");
    }
  }, [selected, labelKey, display_searching_key]);

  const {
    res: optionsRes,
    mutate: fetchOptions,
    isPending: isLoadingOptions,
    error: fetchError,
  } = useAxios({ url: "/api/auth/name" });

  const fetchSuggestions = () => {
    if (query.length < 2) {
      setShowDropdown(false);
      return;
    }

    if (name === "consignee") {
      fetchOptions({ keyname: "name", formId: "shipper", name: query });
    } else if (name === "driver") {
      fetchOptions({ keyname: "first_name", formId: "drivers", name: query });
    } else {
      fetchOptions({ keyname: name, formId: name, name: query });
    }
  };

  useEffect(() => {
    const delay = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(delay);
  }, [query]);

  useEffect(() => {
    console.log(optionsRes);
    if (optionsRes?.data?.list) {
      setOptions(optionsRes.data.list);
    }
  }, [optionsRes]);

  const handleSelect = (option: any) => {
    const displayText = option[display_searching_key] || option[labelKey] || "";
    setDisplayValue(displayText);

    const v = option?.id ?? option[searching_key];

    setValue(name, v || option);
    setShowDropdown(false);
  };

  return (
    <div className="relative">
      <input
        autoComplete="off"
        value={displayValue}
        onChange={(e) => {
          setOptions([]);
          setDisplayValue(e.target.value);
          setQuery(e.target.value);
          setShowDropdown(true);
        }}
        className="h-7 w-full border px-1 py-1 text-xs shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
        {...rest}
      />

      {showDropdown && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
          {isLoadingOptions ? (
            <li className="p-2 text-sm text-center">
              <CircularProgress size={16} />
            </li>
          ) : options.length > 0 ? (
            options?.map((option) => (
              <li
                key={option[display_searching_key]}
                onClick={() => handleSelect(option)}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              >
                {option[display_searching_key]}
              </li>
            ))
          ) : (
            <>
              <li className="px-4 py-2 text-red-500 hover:bg-red-100 cursor-pointer text-sm">
                Not Found
              </li>
            </>
          )}
        </ul>
      )}

      {fetchError && (
        <p className="text-red-500 text-sm mt-1">Failed to load options.</p>
      )}
    </div>
  );
}
